import axios, { AxiosInstance } from 'axios';
import { ApiConfig } from './api.config';

export class Api {
    protected api: AxiosInstance;
    protected auth_token: string = "";

    constructor(auth_token: string = ""){
        let headers = { ...ApiConfig.HEADERS };
        if(auth_token) headers['Authorization'] = auth_token;

        this.api = axios.create({
            baseURL: ApiConfig.URL,
            headers
        });
    }
}